<div class="snackbar-custom-body">
  <span matSnackBarLabel>
    {{ snackBarRef.containerInstance.snackBarConfig.announcementMessage }}
  </span>
  <span class="mat-snack-bar-splitter">|</span>
  <span matSnackBarActions>
    <button matSnackBarAction (click)="snackBarRef.dismissWithAction()">
      <mat-icon>close</mat-icon>
    </button>
  </span>
</div>
